module.exports = {"attributes":{"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.9038 13.9038C14.1228 12.6848 15.7761 12 17.5 12C18.4802 12 19.3732 12.1402 20.2468 12.5207C20.8597 12.7876 21.4321 13.1594 22 13.6393C22.5679 13.1594 23.1403 12.7876 23.7532 12.5207C24.6268 12.1402 25.5198 12 26.5 12C28.2239 12 29.8772 12.6848 31.0962 13.9038C32.3152 15.1228 33 16.7761 33 18.5C33 21.2418 31.1906 23.2531 29.7035 24.7107L22.7071 31.7071C22.3166 32.0976 21.6834 32.0976 21.2929 31.7071L14.2988 24.7131C12.7944 23.258 11 21.2494 11 18.5C11 16.7761 11.6848 15.1228 12.9038 13.9038ZM17.5 14C16.3065 14 15.1619 14.4741 14.318 15.318C13.4741 16.1619 13 17.3065 13 18.5C13 20.3469 14.2007 21.8365 15.695 23.281L15.7071 23.2929L22 29.5858L28.3001 23.2857C29.7923 21.8235 31 20.3359 31 18.5C31 17.3065 30.5259 16.1619 29.682 15.318C28.8381 14.4741 27.6935 14 26.5 14C25.7202 14 25.1132 14.1098 24.5518 14.3543C23.984 14.6016 23.4001 15.0141 22.7071 15.7071C22.3166 16.0976 21.6834 16.0976 21.2929 15.7071C20.5999 15.0141 20.016 14.6016 19.4482 14.3543C18.8868 14.1098 18.2798 14 17.5 14Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
